/**
 * Builds a readable message from axios error responses (backend sends { error, details, code }).
 */
export function getAuthErrorMessage(error, fallback = "Something went wrong") {
  const data = error?.response?.data;
  if (data == null) return error?.message || fallback;
  if (typeof data === "string") return data;
  const parts = [
    data.details,
    data.error,
    data.message,
    Array.isArray(data.errors) ? data.errors.join("; ") : null,
  ].filter(Boolean);
  const text = parts.join(" ").trim();
  return text || error?.message || fallback;
}
